import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const disqualifiedAction = createAsyncThunk(
    'disqualified',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/total-missionqualified`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const disqualifiedSlice = createSlice({
    name: 'disqualified',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(disqualifiedAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(disqualifiedAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(disqualifiedAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const disqualifiedReducer = disqualifiedSlice.reducer
